export default "__VITE_ASSET__Css2SKhk__"